/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { Base, markType, PointUtil } from "igniteui-react-core";
import { INativeCell_$type } from "./INativeCell";
import { RenderingContext } from "igniteui-react-core";
import { Rectangle } from "igniteui-react-core";
import { Line } from "igniteui-react-core";
import { TextBlock } from "igniteui-react-core";
import { Color } from "igniteui-react-core";
import { FontInfo } from "igniteui-react-core";
import { Brush } from "igniteui-react-core";
import { CanvasViewRenderer } from "igniteui-react-core";
import { CanvasPlaceholderView } from "./CanvasPlaceholderView";
import { DeviceUtils } from "igniteui-react-core";
import { Random } from "igniteui-react-core";
import { FontUtil } from "igniteui-react-core";
import { truncate, isNaN_ } from "igniteui-react-core";
/**
 * @hidden
 */
var CanvasGridCellBase = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(CanvasGridCellBase, _super);
    function CanvasGridCellBase(a) {
        var _this = _super.call(this) || this;
        _this.a = null;
        _this.s = true;
        _this.o = true;
        _this.k = null;
        _this.bl = null;
        _this.q = false;
        _this.by = null;
        _this.l = false;
        _this.ap = 1;
        _this.at = 5;
        _this.av = 5;
        _this.au = 5;
        _this.as = 5;
        _this.cw = null;
        _this.ah = 0;
        _this.aj = 0;
        _this.ai = 0;
        _this.ag = 0;
        _this.c4 = new Rectangle();
        _this.c0 = new Line();
        _this.c3 = new Line();
        _this.c1 = new Line();
        _this.cz = new Line();
        _this.c2 = new Line();
        _this.az = 0;
        _this.a1 = 0;
        _this.a2 = 0;
        _this.a3 = 0;
        _this.bn = null;
        _this.j = null;
        _this.al = 0;
        _this.ak = 0;
        _this.an = 0;
        _this.am = 0;
        _this.u = true;
        _this.a0 = NaN;
        _this.cv = new TextBlock();
        _this.cy = Color.u(255, 0, 0, 0);
        _this.t = true;
        _this.ar = 0;
        _this.a4 = 0;
        _this.cx = Color.u(255, 255, 255, 255);
        _this.m = false;
        _this.g = null;
        _this.c = 0;
        _this.e = 0;
        _this.bx = 1;
        _this.r = false;
        _this.ay = 0;
        _this.ax = 0;
        _this.i = ((function () {
            var $ret = new FontInfo();
            $ret.n = "Verdana";
            $ret.d = 12;
            return $ret;
        })());
        _this.p = true;
        _this.bq = -1;
        _this.bv = 0;
        _this.bw = 0;
        _this.n = false;
        _this.bo = 0;
        _this.b = 0;
        _this.aq = NaN;
        _this.h = null;
        _this.bs = -1;
        _this.ao = NaN;
        _this.f = 1;
        _this.aw = 1;
        _this.bl = a;
        return _this;
    }
    Object.defineProperty(CanvasGridCellBase.prototype, "z", {
        get: function () {
            return this.o;
        },
        set: function (a) {
            this.o = a;
        },
        enumerable: false,
        configurable: true
    });
    CanvasGridCellBase.prototype.ck = function (a) {
        this.k = a;
    };
    CanvasGridCellBase.prototype.b5 = function () {
        this.o = true;
        if (this.k != null) {
            this.k();
        }
    };
    Object.defineProperty(CanvasGridCellBase.prototype, "isCanvasBased", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "bm", {
        get: function () {
            return this.bl;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "isRemoved", {
        get: function () {
            return this.q;
        },
        set: function (a) {
            this.q = a;
        },
        enumerable: false,
        configurable: true
    });
    CanvasGridCellBase.prototype.cm = function (a) {
        this.by = a;
        this.o = true;
        this.s = true;
    };
    Object.defineProperty(CanvasGridCellBase.prototype, "templateContext", {
        get: function () {
            return this.j.g();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "v", {
        get: function () {
            return this.l;
        },
        set: function (a) {
            this.l = a;
        },
        enumerable: false,
        configurable: true
    });
    CanvasGridCellBase.prototype.get_ab = function () {
        return false;
    };
    Object.defineProperty(CanvasGridCellBase.prototype, "ab", {
        get: function () {
            return this.get_ab();
        },
        enumerable: false,
        configurable: true
    });
    CanvasGridCellBase.prototype.cc = function (a, b, c, d, e) {
        this.o = true;
        this.cw = a;
        this.ah = b;
        this.aj = c;
        this.ai = d;
        this.ag = e;
        this.s = true;
    };
    CanvasGridCellBase.prototype.cd = function (a) {
        this.o = true;
        this.ap = a;
        this.cv._opacity = this.ap;
    };
    Object.defineProperty(CanvasGridCellBase.prototype, "bb", {
        get: function () {
            return this.at;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "bd", {
        get: function () {
            return this.av;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "bc", {
        get: function () {
            return this.au;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "ba", {
        get: function () {
            return this.as;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "a6", {
        get: function () {
            return this.ah;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "a8", {
        get: function () {
            return this.aj;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "a7", {
        get: function () {
            return this.ai;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "a5", {
        get: function () {
            return this.ag;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "bf", {
        get: function () {
            return this.az;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "bh", {
        get: function () {
            return this.a1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "bi", {
        get: function () {
            return this.a3;
        },
        enumerable: false,
        configurable: true
    });
    CanvasGridCellBase.prototype.get_ac = function () {
        return false;
    };
    Object.defineProperty(CanvasGridCellBase.prototype, "ac", {
        get: function () {
            return this.get_ac();
        },
        enumerable: false,
        configurable: true
    });
    CanvasGridCellBase.prototype.b1 = function (a, b, c, d, e, f) {
        var g = true;
        var h = true;
        var i = false;
        if (this.ac) {
            g = false;
            h = false;
            i = false;
        }
        this.b2(a, b, c, d, e, f, g, h, i);
    };
    Object.defineProperty(CanvasGridCellBase.prototype, "resized", {
        get: function () {
            return this.u;
        },
        enumerable: false,
        configurable: true
    });
    CanvasGridCellBase.prototype.ensureCorrectSize = function () {
        this.u = this.w(this.aw);
        return this.u;
    };
    CanvasGridCellBase.prototype.b2 = function (a, b, c, d, e, f, g, h, i) {
        if (!this.t) {
            return;
        }
        if (this.bx != 1) {
            a.ad(this.bx);
        }
        this.aw = f;
        if (!i) {
            this.b3();
            this.ensureCorrectSize();
        }
        if (this.z || this.u || i) {
            this.z = false;
            var j = this.j;
            if (this.p || this.u || (this.i != null && this.i.g != this.bq)) {
                this.p = false;
                this.bq = this.i.g;
                j.ac(this.i);
            }
            if (f != 1) {
                this.j.z();
                this.j.aa(f, f);
            }
            if (g) {
                this.b6();
            }
            if (h) {
                this.b7(this.j);
            }
            if (f != 1) {
                this.j.y();
            }
        }
        if (!i) {
            var k = Math.round((d - b) * f);
            var l = Math.round((e - c) * f);
            if (this.al == this.an && this.ak == this.am) {
                a.m(this.bn.getNativeElement(), 1, k, l, this.al, this.ak);
            }
            else {
                a.n(this.bn.getNativeElement(), 1, 0, 0, this.al, this.ak, k, l, this.al, this.ak);
            }
        }
        if (this.bx != 1) {
            a.ad(1);
        }
    };
    CanvasGridCellBase.prototype.b6 = function () {
        if (!this.m) {
            this.j.k(0, 0, this.an, this.am);
        }
        this.c4.n = 0;
        this.c4.o = 0;
        this.c4.width = this.a4;
        this.c4.height = this.ar;
        this.j.v(this.c4);
        if (this.cw != null) {
            if (this.ah > 0) {
                this.c0.am = 0;
                this.c0.ak = this.ah / 2;
                this.c0.an = this.ar;
                this.c0.al = this.ah / 2;
                this.c0._stroke = this.cw;
                this.c0.ac = this.ah;
                this.j.r(this.c0);
            }
            if (this.ai > 0) {
                this.c1.am = 0;
                this.c1.ak = Math.max(0, (this.a4 - (this.ai / 2)));
                this.c1.an = this.ar;
                this.c1.al = Math.max(0, (this.a4 - (this.ai / 2)));
                this.c1._stroke = this.cw;
                this.c1.ac = this.ai;
                this.j.r(this.c1);
            }
            if (this.aj > 0) {
                this.c3.am = this.aj / 2;
                this.c3.ak = this.ah;
                this.c3.an = this.aj / 2;
                this.c3.al = Math.max(0, (this.a4 - (this.ai / 2)));
                this.c3._stroke = this.cw;
                this.c3.ac = this.aj;
                this.j.r(this.c3);
            }
            if (this.ag > 0) {
                this.cz.am = Math.max(0, this.ar - (this.ag / 2));
                this.cz.ak = this.ah;
                this.cz.an = Math.max(0, this.ar - (this.ag / 2));
                this.cz.al = Math.max(0, (this.a4 - (this.ai / 2)));
                this.cz._stroke = this.cw;
                this.cz.ac = this.ag;
                this.j.r(this.cz);
            }
        }
    };
    CanvasGridCellBase.prototype.cj = function (a) {
        this.aw = a;
    };
    CanvasGridCellBase.prototype.renderStandardContent = function () {
        this.b2(this.j, 0, 0, 0, 0, this.aw, false, true, true);
    };
    CanvasGridCellBase.prototype.renderStandardBackground = function () {
        this.b2(this.j, 0, 0, 0, 0, this.aw, true, false, true);
    };
    CanvasGridCellBase.prototype.b7 = function (a) {
        if (this.s) {
            this.cu();
            this.s = false;
        }
        if (this.cv.ak != null) {
            this.cv.n = this.az;
            this.cv.o = this.a2;
            this.j.w(this.cv);
            if (this.r) {
                this.c2.ac = 1;
                this.c2.ak = this.az;
                this.c2.am = this.a3 - 2;
                this.c2.al = this.az + (this.a1 - this.az);
                this.c2.an = this.a3 - 2;
                this.c2._stroke = this.cv.am;
                this.j.r(this.c2);
            }
        }
    };
    CanvasGridCellBase.prototype.b3 = function () {
        if (this.bn == null) {
            this.bn = this.bl.createElement("canvas");
            var a_1 = this.bl.get2DCanvasContext(this.bn);
            var b = ((function () {
                var $ret = new CanvasViewRenderer();
                $ret.h$d = a_1;
                return $ret;
            })());
            this.j = new RenderingContext(b, a_1);
            this.s = true;
        }
    };
    CanvasGridCellBase.prototype.w = function (a) {
        var b = Math.round(this.a4 * a);
        var c = Math.round(this.ar * a);
        this.al = b;
        this.ak = c;
        var d = this.be(b);
        var e = this.be(c);
        if (d != this.an || e != this.am) {
            this.bn.setAttribute("width", d + "px");
            this.bn.setAttribute("height", e + "px");
            this.an = d;
            this.am = e;
            this.al = b;
            this.ak = c;
            return true;
        }
        return false;
    };
    CanvasGridCellBase.prototype.be = function (a) {
        return a;
    };
    CanvasGridCellBase.prototype.ci = function (a, b, c, d) {
        this.o = true;
        this.at = a;
        this.av = b;
        this.au = c;
        this.as = d;
        this.s = true;
    };
    Object.defineProperty(CanvasGridCellBase.prototype, "bg", {
        get: function () {
            return this.a0;
        },
        set: function (a) {
            this.a0 = a;
        },
        enumerable: false,
        configurable: true
    });
    CanvasGridCellBase.prototype.cn = function (a) {
        var _this = this;
        this.o = true;
        this.cy = a;
        this.cv.am = ((function () {
            var $ret = new Brush();
            $ret.color = _this.cy;
            return $ret;
        })());
    };
    CanvasGridCellBase.prototype.get_aa = function () {
        return false;
    };
    Object.defineProperty(CanvasGridCellBase.prototype, "aa", {
        get: function () {
            return this.get_aa();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "ad", {
        get: function () {
            return this.t;
        },
        set: function (a) {
            this.o = true;
            this.t = a;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "a9", {
        get: function () {
            return this.ar;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CanvasGridCellBase.prototype, "bk", {
        get: function () {
            return this.a4;
        },
        enumerable: false,
        configurable: true
    });
    CanvasGridCellBase.prototype.cf = function (a) {
        this.o = true;
        this.ar = a;
        this.c4.height = this.ar;
    };
    CanvasGridCellBase.prototype.cp = function (a) {
        this.o = true;
        this.a4 = a;
        this.c4.width = this.a4;
        this.s = true;
    };
    CanvasGridCellBase.prototype.b0 = function () {
        if (!this.ab) {
            return;
        }
        this.l = true;
        this.g = new CanvasPlaceholderView();
        this.c = 0;
        this.e = 1;
        this.g.l = Color.u(120, 120, 120, 120);
        this.g.h = 0;
    };
    CanvasGridCellBase.prototype.cb = function (a) {
        var _this = this;
        this.o = true;
        this.cx = a;
        this.m = this.cx.l == 255;
        this.c4._fill = ((function () {
            var $ret = new Brush();
            $ret.color = _this.cx;
            return $ret;
        })());
    };
    CanvasGridCellBase.prototype.ch = function (a) {
        this.o = true;
        this.bx = a;
    };
    CanvasGridCellBase.prototype.cl = function (a) {
        this.r = a;
        this.o = true;
    };
    CanvasGridCellBase.prototype.ct = function (a) {
        if (!this.ab) {
            return;
        }
        this.o = true;
        this.g.h = (a * 0.20000000298023224);
    };
    CanvasGridCellBase.prototype.b4 = function (a, b, c, d) {
        if (this.g != null) {
            var e = this.ay;
            var f = this.ax;
            if (this.e == 1) {
                b = truncate((b + (d / 2) - (f / 2)));
            }
            else if (this.e == 2) {
                b = truncate((b + (d) - (f)));
            }
            if (this.c == 1) {
                a = truncate((a + (c / 2) - (e / 2)));
            }
            else if (this.c == 2) {
                a = truncate((a + (c) - (e)));
            }
        }
    };
    CanvasGridCellBase.prototype.ce = function (a) {
        this.i = a;
        this.p = true;
        this.o = true;
        this.s = true;
    };
    CanvasGridCellBase.prototype.cs = function (a) {
        if (!this.ab) {
            return;
        }
        this.o = true;
        var b = DeviceUtils.f(12);
        if (a.ag != null && !isNaN_(a.ag.d)) {
            b = a.ag.d;
        }
        if (this.ax != b) {
            this.ax = b;
        }
        var c = a.gu * 0.2;
        var d = a.fc * 0.6;
        if (this.ay >= c && this.ay <= d) {
            return;
        }
        var e = (CanvasGridCellBase.bu.nextDouble() * (d - c) + c);
        if (this.ay != e) {
            this.ay = e;
        }
    };
    CanvasGridCellBase.prototype.cq = function (a, b) {
        if (!this.ab) {
            return;
        }
        this.o = true;
        this.c = a;
        this.e = b;
    };
    CanvasGridCellBase.prototype.cr = function (a) {
        if (!this.ab) {
            return;
        }
        this.o = true;
    };
    CanvasGridCellBase.prototype.ca = function (a) {
        this.a = a;
    };
    Object.defineProperty(CanvasGridCellBase.prototype, "d", {
        get: function () {
            return this.b;
        },
        enumerable: false,
        configurable: true
    });
    CanvasGridCellBase.prototype.cg = function (a) {
        this.b = a;
        this.o = true;
        this.s = true;
    };
    CanvasGridCellBase.prototype.cu = function () {
        if (this.by == null) {
            return;
        }
        if (this.j == null) {
            return;
        }
        if (this.p || (this.i != null && this.i.g != this.bq)) {
            this.p = false;
            this.bq = this.i.g;
            this.j.ac(this.i);
        }
        var a;
        if (this.h != this.i || this.bs != this.i.g) {
            this.h = this.i;
            this.bs = this.i.g;
            this.aq = FontUtil.getCurrentFontHeight(this.bl, this.i);
        }
        a = this.aq;
        var b = 0;
        var c = 0;
        var d = this.a4;
        var e = this.ar;
        d -= (this.ah + this.at + this.ai + this.au);
        e -= (this.aj + this.av + this.ag + this.as);
        d = Math.max(d, 0);
        e = Math.max(e, 0);
        var f = d;
        if (!isNaN_(this.a0) && this.a0 < d) {
            f = this.a0;
        }
        var g = this.bj(this.cv, this.by, f, this.j);
        switch (this.b) {
            case 0:
                b = this.at + this.ah;
                break;
            case 3:
            case 1:
                b = this.at + this.ah + ((d / 2) - (g / 2));
                break;
            case 2:
                b = Math.max(0, (this.a4 - (this.au + this.ai))) - g;
                break;
        }
        switch (this.f) {
            case 0:
                c = this.av + this.aj;
                break;
            case 3:
            case 1:
                c = this.av + this.aj + ((e / 2) - (a / 2));
                break;
            case 2:
                c = Math.max(0, (this.ar - (this.as + this.ag))) - a;
                break;
        }
        this.az = b;
        this.a1 = this.az + g;
        this.a2 = c;
        this.a3 = this.a2 + (a / 2);
        this.o = true;
    };
    CanvasGridCellBase.prototype.bj = function (a, b, c, d) {
        var e = b;
        var f = e.length;
        var g = ("\u2026");
        if (isNaN_(this.ao)) {
            this.ao = d.f(g);
        }
        if (c <= this.ao) {
            a.ak = g;
            return this.ao;
        }
        var h = d.f(e);
        if (h <= c) {
            a.ak = b;
            return h;
        }
        var i = c / h;
        var j = truncate(Math.ceil(f * i));
        var k = e.substr(0, j) + g;
        var l = d.f(k);
        if (l > c) {
            f = j;
        }
        else {
            j = j + 1;
            k = e.substr(0, j) + g;
            l = d.f(k);
            if (l > c) {
                f = j;
            }
        }
        while (h > c && f > 0) {
            f--;
            e = e.substr(0, f) + g;
            h = d.f(e);
        }
        a.ak = e;
        return h;
    };
    CanvasGridCellBase.prototype.co = function (a) {
        this.f = a;
        this.o = true;
        this.s = true;
    };
    CanvasGridCellBase.prototype.af = function (a) {
        return a.isClickActionDesired;
    };
    CanvasGridCellBase.prototype.onContactStarted = function (a, b) {
        if (this.a != null && this.af(this.a)) {
            this.bv = a.pageX;
            this.bw = a.pageY;
            this.a.mouseDownCell(this.bv, this.bw);
        }
    };
    CanvasGridCellBase.prototype.onContactMoved = function (a, b) {
        if (this.a != null && this.af(this.a)) {
            var c = a.pageX;
            var d = a.pageY;
            if (this.a.isMouseDown) {
                if (b) {
                    if (PointUtil.equals(this.a.mousePosition, null) || Math.abs(c - this.a.mousePosition.x) > CanvasGridCellBase.br || Math.abs(d - this.a.mousePosition.y) > CanvasGridCellBase.br) {
                        this.a.mouseUpCell(c, d);
                    }
                    else {
                        a.stopPropagation();
                    }
                }
                else {
                    if (PointUtil.equals(this.a.mousePosition, null)) {
                        this.a.mouseUpCell(c, d);
                    }
                    else {
                        if (Math.abs(c - this.a.mousePosition.x) > CanvasGridCellBase.bp || Math.abs(d - this.a.mousePosition.y) > CanvasGridCellBase.bp) {
                            this.a.isControlPressed = a.ctrlKey;
                            this.a.dragStarted();
                        }
                    }
                }
            }
        }
    };
    CanvasGridCellBase.prototype.onContactCompleted = function (a, b) {
        if (this.a != null && this.af(this.a)) {
            var c = a.pageX;
            var d = a.pageY;
            if (PointUtil.equals(this.a.mousePosition, null) || Math.abs(c - this.a.mousePosition.x) > CanvasGridCellBase.br || Math.abs(d - this.a.mousePosition.y) > CanvasGridCellBase.br || this.a.isDrag) {
                this.a.mouseUpCell(c, d);
            }
            if (this.a.isCellDown()) {
                this.a.isControlPressed = a.ctrlKey;
                this.a.isShiftPressed = a.shiftKey;
                switch (a.which) {
                    case 1:
                        this.a.clickCell(0);
                        break;
                    case 2:
                        this.a.clickCell(1);
                        break;
                    case 3:
                        this.a.clickCell(2);
                        break;
                    default:
                        this.a.clickCell(3);
                        break;
                }
                this.a.mouseUpCell(a.pageX, a.pageY);
            }
        }
    };
    CanvasGridCellBase.prototype.onDoubleClick = function (a) {
        switch (a.which) {
            case 1:
                this.a.doubleClicked(0);
                break;
            case 2:
                this.a.doubleClicked(1);
                break;
            case 3:
                this.a.doubleClicked(2);
                break;
            default:
                this.a.doubleClicked(3);
                break;
        }
    };
    CanvasGridCellBase.prototype.detach = function () {
    };
    CanvasGridCellBase.$t = markType(CanvasGridCellBase, 'CanvasGridCellBase', Base.$, [INativeCell_$type]);
    CanvasGridCellBase.bu = new Random(0);
    CanvasGridCellBase.br = 10;
    CanvasGridCellBase.bp = 3;
    return CanvasGridCellBase;
}(Base));
export { CanvasGridCellBase };
//# sourceMappingURL=CanvasGridCellBase.js.map
